import styled, { css } from 'styled-components';
export const Container = styled.div `
  display: flex;
  position: relative;
  padding: var(--space-300) var(--space-400);
  border: 1px solid var(--border-primary);
  cursor: pointer;
  border-radius: var(--radius-brand);

  ${({ selected }) => selected &&
    css `
      padding: calc(var(--space-300) - 1px) calc(var(--space-400) - 1px);
      border: 2px solid var(--border-active);
      border-top-color: var(--border-active) !important;
    `}
`;
export const RadioContainer = styled.div `
  margin-right: 14px;
`;
export const Content = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
`;
export const Label = styled.div `
  font-size: var(--font-size-400);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-400);
  margin-bottom: var(--space-100);
`;
export const Text = styled.div `
  font-size: var(--font-size-300);
  line-height: var(--font-line-height-300);
  letter-spacing: var(--font-letter-spacing-loose);
`;
export const SavingsTag = styled.div `
  position: absolute;
  top: 0;
  right: 0;
  border-radius: var(--radius-brand);
  padding: var(--space-50) var(--space-150);
  font-size: var(--font-size-200);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-200);
  color: var(--text-on-brand);
  background: linear-gradient(var(--bg-pro-gradient-start), var(--bg-pro-gradient-end));
  background: radial-gradient(
    128.44% 143.02% at 96.27% -10.78%,
    var(--bg-pro-gradient-start) 0%,
    var(--bg-pro-gradient-end) 100%
  );
`;
